import { Outlet } from '@tanstack/react-router';
import { InitialLoading } from '@anytag/shared-molecules';
import { initialState } from '@anytag/auth';
import { client } from '@anytag/providers';
import { RouterIds, createRouter } from '@anytag/router';
import { objectEntries } from '@anytag/shared-assets';
import { VerifyTokenAsync } from '../components';
import { NotFound } from '../pages/public';
import { PrivateRouter } from './_private-routes';
import { PublicRoutes } from './_public-routes';
import { RouterMapType } from './types';

export const router = createRouter({
  auth: initialState,
  dispatch: () => null,
  invalidate: () => null,
  queryClient: client,
  defaultRoute: undefined,
  hashtagAnalyticsCountryId: '',
  setHashtagAnalyticsCountryId: () => null
});

const routerMap = {
  __root__: [
    () => (
      <VerifyTokenAsync>
        <Outlet />
        {/* causes crash of HMR not sure why yet */}
        {/* <TanStackRouterDevtools position="bottom-right" /> */}
      </VerifyTokenAsync>
    ),
    {}
  ],
  '/': [() => <InitialLoading />, {}],
  /** @private */
  ...PrivateRouter,
  /** @public */
  ...PublicRoutes,
  '/not-found': [NotFound, {}]
} as const satisfies RouterMapType<RouterIds>;

objectEntries(routerMap).forEach(([path, [component, options]]) => {
  const foundRoute = router.routesById[path as RouterIds];

  foundRoute.update({
    component: component
  });
  if ('validateSearch' in options) {
    foundRoute.options.validateSearch = options.validateSearch;
  }
  if ('beforeLoad' in options) {
    foundRoute.options.beforeLoad = options.beforeLoad;
  }
  if ('loader' in options) {
    foundRoute.options.loader = options.loader;
  }
  if ('loaderDeps' in options) {
    foundRoute.options.loaderDeps = options.loaderDeps;
  }
  if ('params' in options) {
    foundRoute.options.params = options.params;
  }
});
